/**
 * Shared shipping schemas and types.
 *
 * Extracted to a leaf file (no `fetchApi` import) so other networking files
 * such as `networking/carts.api.ts` can reuse `shippingOptionSchema` without
 * forming a cycle through `lib/api-helpers.ts`.
 */
import { z } from "zod";

export const shippingOptionSchema = z.object({
  id: z.string(),
  title: z.string(),
  delivery_time_estimate: z.string().nullish(),
  price: z.number().nullish(),
  price_label: z.string().nullish(),
});

export type ShippingMethod = z.infer<typeof shippingOptionSchema>;
